export var TrackingEvent;
(function (TrackingEvent) {
    TrackingEvent["ACCEPT_ITINERARY_OFFER"] = "acceptItineraryOffer";
    TrackingEvent["ADD_LAB_BRANCH"] = "addLabBranch";
    /** Triggered whenever a user puts in an address in the scheduling flow that is not part of our serviceRegions */
    TrackingEvent["ADDRESS_OUTSIDE_OF_SERVICE_REGIONS"] = "addressOutsideOfServiceRegions";
    /** When the app finishes loading after launch */
    TrackingEvent["APP_FINISH_LOADING"] = "appFinishLoading";
    /** Used for tracking specific initialization events (e.g. Firebase init) */
    TrackingEvent["APP_INITIALIZATION_EVENT"] = "appInitializationEvent";
    /** When the app first launches. Triggered immediately after segment init. */
    TrackingEvent["APP_LAUNCH"] = "appLaunch";
    TrackingEvent["ARRIVED_AT_WAYPOINT"] = "arrivedAtWaypoint";
    TrackingEvent["ASSIGN_NURSE_TO_ITINERARY"] = "assignNurseToItinerary";
    /**
     * Send a cloud-side fax automatically
     * to the processing lab
     */
    TrackingEvent["AUTO_FAX_REQ_FORM"] = "autoFaxReqForm";
    TrackingEvent["BOOKING_DETAILS"] = "bookingDetails";
    /** CarePro app - triggered in the ContactAlert component */
    TrackingEvent["CALL_PATIENT"] = "callPatient";
    /** In contact modal on the CarePro app */
    TrackingEvent["CALL_PRESCRIBER"] = "callPrescriber";
    TrackingEvent["CANCEL_BOOKING"] = "cancelBooking";
    TrackingEvent["CHARTING_DONE"] = "chartingDone";
    TrackingEvent["CHECK_DOB"] = "checkDob";
    /** Click events */
    TrackingEvent["CLICK_ADD_EXTERNAL_JOB"] = "clickAddExternalJob";
    TrackingEvent["CLICK_AVAILABILITY_PREFERENCES"] = "clickAvailabilityPreferences";
    /** Patient scheduling date-of-birth authentication tracker */
    TrackingEvent["CLICK_DOB_FIELD"] = "clickDobField";
    /** Patient scheduling date-of-birth authentication tracker */
    TrackingEvent["CLICK_DOB_CALENDAR_COMPONENT"] = "clickDobCalendarComponent";
    TrackingEvent["CLICK_LOCATION_PREFERENCES"] = "clickLocationPreferences";
    /**
     * Cloud - Triggered when an error occurs that is reported to Sentry. Includes
     * error message, calling userID, function name and arguments.
     */
    TrackingEvent["CLOUD_ERROR"] = "cloudError";
    TrackingEvent["COMPLETED_NURSE_COURSE"] = "completedNurseCourse";
    TrackingEvent["COMPLETED_NURSE_LESSON"] = "completedNurseLesson";
    TrackingEvent["COMPLETE_CHARTING"] = "completeCharting";
    TrackingEvent["COMPLETE_SHIFT_CHECKIN"] = "completeShiftCheckin";
    TrackingEvent["COMPLETE_SHIFT_GEOCHECK"] = "completeShiftGeoCheck";
    /**
     * Cloud
     *
     * Fired when the updateShiftCompletion function is ran and the shift status
     * is being set to complete
     */
    TrackingEvent["COMPLETED_SHIFT"] = "completedShift";
    TrackingEvent["CONFIRM_BOOKING"] = "confirmBooking";
    /** Patient scheduling date-of-birth authentication tracker */
    TrackingEvent["CONFIRM_DOB_INPUT"] = "confirmDobInput";
    TrackingEvent["CONFIRM_DRAFT_WAYPOINTS"] = "confirmDraftWaypoints";
    TrackingEvent["CONFIRM_INVITATION_TO_OFFICE"] = "confirmInvitationToOffice";
    /**
     * Pro
     *
     * Nurse wallet feature
     *
     * Fired after a bank account is successfully connected to a nurse's wallet
     */
    TrackingEvent["CONNECT_WALLET"] = "connectWallet";
    /**
     * Pro
     * Store module: Office
     * Action: saveContactSettings
     */
    TrackingEvent["CONTACT_SETTINGS_UPDATED"] = "contactSettingsUpdated";
    TrackingEvent["CREATE_BOOKING"] = "createBooking";
    TrackingEvent["CREATE_DRAFT_ORDER"] = "createDraftOrder";
    TrackingEvent["CREATE_NOTE"] = "createNote";
    TrackingEvent["CREATE_ORDER"] = "createOrder";
    /**
     * Dashboard
     *
     * Offices page
     *
     * Triggered when a user submits the form to create a new office
     */
    TrackingEvent["CREATED_PHYSICIAN_OFFICE"] = "createdPhysicianOffice";
    /**
     * Dashboard
     *
     * Place group page
     *
     * Triggered when a user clicks "Initialise" on the Lab Office
     */
    TrackingEvent["CREATED_LAB_OFFICE"] = "createdLabOffice";
    /**
     * Useful for creating custom temporary tracking events to debug issues that
     * we cannot reproduce on dev.
     */
    TrackingEvent["DEBUG"] = "debug";
    /**
     * Cloud - Triggered when `setTimeSlotsTrigger` deletes all time
     * slots in firebase and algolia.
     */
    TrackingEvent["DELETE_ALL_TIME_SLOTS"] = "deleteAllTimeSlots";
    /**
     * Triggered when a patient attemps to book a timeslot that is already booked.
     */
    TrackingEvent["DOUBLE_BOOKING_ATTEMPT"] = "doubleBookingAttempt";
    /**
     * Cloud - Triggered when the link between the
     * DraftWaypoints, DraftProcedures, and DraftOrder is synchronised
     */
    TrackingEvent["DRAFT_ORDER_DRAFT_WAYPOINT_CREATION"] = "draftOrderDraftWaypointCreation";
    TrackingEvent["DRIVE_TO_WAYPOINT"] = "driveToWaypoint";
    TrackingEvent["EDIT_SERVICE_REGIONS"] = "editServiceRegions";
    TrackingEvent["EDIT_SHIFT"] = "editShift";
    /**
     * Scheduling flow
     *
     * Triggered when there are no slots to display on the Time slot selection
     * page
     */
    TrackingEvent["EMPTY_SCHEDULING_EVENT"] = "emptySchedulingEvent";
    /**
     * Cloud - Triggered when a draft waypoint status
     * is changed to 'finalized'
     */
    TrackingEvent["FINALIZE_DRAFT_WAYPOINT"] = "finalizeDraftWaypoint";
    TrackingEvent["FINALIZE_ORDER_LATER"] = "finalizeOrderLater";
    TrackingEvent["FINALIZE_ORDER_NOW"] = "finalizeOrderNow";
    TrackingEvent["FINISH_ADDING_SUPPLIES"] = "finishAddingSupplies";
    TrackingEvent["FINISH_GEO_CHECK"] = "finishGeoCheck";
    TrackingEvent["FINISH_ITINERARY"] = "finishItinerary";
    TrackingEvent["FINISH_PROCEDURE"] = "finishProcedure";
    TrackingEvent["FINISH_PROCEDURE_BAG_PACKING"] = "finishProcedureBagPacking";
    /**
     * Packer finishing a packing flow
     */
    TrackingEvent["FINISH_PROCEDURE_KIT_PACKING"] = "finishProcedureKitPacking";
    TrackingEvent["FINISH_WAYPOINT"] = "finishWaypoint";
    TrackingEvent["FINISH_WAYPOINT_ACTION"] = "finishWaypointAction";
    /**
     * CarePro app - This button is found as the button with the "speechmark" icon
     *
     * Currently, depending on where it is used, it either triggers the contact
     * modal or the intercom messenger
     *
     * This will track the click on this button and the component where it
     * was clicked
     */
    TrackingEvent["FOOTER_CONTACT_BUTTON"] = "footerContactButton";
    /**
     * CarePro app - Center button with the 'i' icon
     *
     * This button is found in the footer which is used in some places during the
     * patient visit and drop off flows
     *
     * It returns the user to the details page relevant to the flow that they are
     * on
     *
     * This will track the click on this button and the component where it
     * was clicked
     */
    TrackingEvent["FOOTER_INFO_BUTTON"] = "footerInfoButton";
    TrackingEvent["FULFILL_PROCEDURE"] = "fulfillProcedure";
    /**
     * clicking 'log out' on the geo enforcement screen on pro
     */
    TrackingEvent["GEO_ENFORCEMENT_LOGOUT"] = "geoEnforcementLogout";
    /**
     * clicking 'retry' on the geo enforcement screen on pro
     */
    TrackingEvent["GEO_ENFORCEMENT_RETRY"] = "geoEnforcementRetry";
    /**
     * on inital invocation of geo enforcement screen on pro,
     * only the first time the screen is invoked
     */
    TrackingEvent["GEO_ENFORCEMENT_TRIGGERED"] = "geoEnforcementTriggered";
    /**
     * Order intake flow
     *
     * Fired when a new order is initialized
     */
    TrackingEvent["INITIALIZE_ORDER"] = "initializeOrder";
    TrackingEvent["INITIALIZE_SAMPLE"] = "initializeSample";
    TrackingEvent["INVITE_COWORKER"] = "invite coworker to office";
    TrackingEvent["INVITE_NURSE_TO_ITINERARY"] = "inviteNurseToItinerary";
    TrackingEvent["LATE_SHIFT_CHECK_IN"] = "lateShiftCheckIn";
    TrackingEvent["LOGIN_PRO_FORGOT_PASSWORD"] = "login pro_forgot password";
    TrackingEvent["LOGIN_PRO_SIGN_UP_HERE"] = "login pro_sign up here";
    TrackingEvent["LOGOUT"] = "logout";
    TrackingEvent["NURSE_ACCEPTED_SHIFT_OFFER"] = "nurseAcceptedShiftOffer";
    TrackingEvent["NURSE_DECLINED_ITINERARY_OFFER"] = "nurseDeclinedItineraryOffer";
    TrackingEvent["NURSE_DECLINED_SHIFT_OFFER"] = "nurseDeclinedShiftOffer";
    TrackingEvent["NURSE_NEW_ITINERARY_OFFER"] = "nurseNewItineraryOffer";
    TrackingEvent["OPEN_NURSE_COURSE"] = "openNurseCourse";
    /**
     * Cloud
     *
     * OnWriteOrder
     *
     * Triggered after the link between the Draft Waypoints, Procedures and Order
     * is synchronized and the Draft Waypoints are created
     *
     * TODO: enum value and string should be identical, fix this
     */
    TrackingEvent["ORDER_DRAFT_WAYPOINT_CREATION"] = "orderDraftWaypointsCreation";
    /**
     * Triggered on the patient initiated scheduling flow,
     * after completed the practice info page.
     */
    TrackingEvent["ORDER_INTAKE_DOCTOR_INFO"] = "orderIntakeDoctorInfo";
    /** Cloud - When faxes are submitted via Dashboard `/files` route */
    TrackingEvent["OUTBOUND_FAX"] = "outboundFax";
    /** Whenever a patient accesses the scheduling flow */
    TrackingEvent["PATIENT_SCHEDULING"] = "patientScheduling";
    /**
     * When locations are fetched from a fulfillment provider.
     *
     * Used to tell python to potentially add new fulfillment provider-sourced
     * places to the database.
     */
    TrackingEvent["PLACES_FROM_FULFILLMENT_INTEGRATION"] = "placesFromFulfillmentIntegration";
    /** Pro - Triggered when a Packer enters the supply transfer flow */
    TrackingEvent["PICK_AND_PACK_TRANSFER"] = "pickAndPackTransfer";
    /** This event get triggered whenever a user is entering the /time and /time-range page of the scheduling flow. */
    TrackingEvent["SCHEDULING_TIME_PICKER"] = "schedulingTimePicker";
    /**
     * From dashboard and when QA is submitted
     */
    TrackingEvent["QA_APPROVAL"] = "qaApproval";
    /** Initiating the re-order flow on office side */
    TrackingEvent["RE_ORDER"] = "reOrder";
    TrackingEvent["REJECT_DRAFT_WAYPOINT"] = "rejectDraftWaypoint";
    TrackingEvent["RETIRE_SKU"] = "retireSku";
    TrackingEvent["SAVE_EXTERNAL_JOB"] = "saveExternalJob";
    TrackingEvent["SAVE_LAB_RESULTS"] = "saveLabResults";
    TrackingEvent["SAVE_RESULTS"] = "saveResults";
    /** Pro - Triggered for every single barcode scan, including invalid scans. */
    TrackingEvent["SCAN_ITEM"] = "scanItem";
    /**
     * Whenever the user is directed to the visit overview page in the scheduling flow
     */
    TrackingEvent["SCHEDULE_VISIT_OVERVIEW"] = "scheduleVisitOverview";
    /** Cloud - Reports on the result of `setTimeSlotsTrigger` */
    TrackingEvent["SCHEDULING_MODEL_TRIGGER"] = "schedulingModelTrigger";
    TrackingEvent["SEND_EMAIL_BOOKING_STATUS_UPDATE"] = "sendEmailBookingStatusUpdate";
    TrackingEvent["SEND_OFFICE_INVITATION"] = "sendOfficeInvitation";
    TrackingEvent["SEND_SMS"] = "sendSMS";
    TrackingEvent["SET_CHARTING_CHECKBOX"] = "setChartingCheckbox";
    TrackingEvent["SET_DEFAULT_OFFICE_ORDER_SETTINGS"] = "setDefaultOfficeOrderSettings";
    TrackingEvent["SET_PAYMENT"] = "setPayment";
    TrackingEvent["SET_PROCEDURE_STATUS"] = "setProcedureStatus";
    /** Cloud - Triggered when these are changed in a User's shift settings */
    TrackingEvent["SET_SHIFT_AVAILABILITY_PREFERENCES"] = "setShiftAvailabilityPreferences";
    /** Cloud - Triggered when these are changed in a User's shift settings */
    TrackingEvent["SET_SHIFT_LOCATION_PREFERENCES"] = "setShiftLocationPreferences";
    /** Cloud - Triggered when a supply shipment is created/updated */
    TrackingEvent["SET_SUPPLY_SHIPMENT"] = "setSupplyShipment";
    /** Cloud - Triggered when a supply transfer is created/updated */
    TrackingEvent["SET_SUPPLY_TRANSFER"] = "setSupplyTransfer";
    /** Pro Packer - Triggered upon attempt to find which place a packer is at */
    TrackingEvent["SET_USER_ASSOCIATED_PLACE_ID"] = "setUserAssociatedPlaceID";
    TrackingEvent["SET_WAYPOINT_ACTION_STATUS"] = "setWaypointActionStatus";
    TrackingEvent["SHIFT_PAYMENT_ASSIGNMENT"] = "shiftPaymentAssignment";
    /** Pro Packer - Starting a shipping flow */
    TrackingEvent["SHIP_TRANSFER"] = "shipTransfer";
    /** Triggered when packing is complete */
    TrackingEvent["SHIPPING_CONFIRMATION"] = "shippingConfirmation";
    /** CarePro app - event triggered from ContactAlert component */
    TrackingEvent["SMS_PATIENT"] = "smsPatient";
    TrackingEvent["SIGNUP_NURSE_INFORMATION_COMPLETE"] = "signup nurse/information_complete";
    TrackingEvent["SIGNUP_NURSE_INTERVIEW_SCHEDULE_EVENT"] = "signup nurse/interview_schedule event";
    TrackingEvent["SIGNUP_NURSE_PERSONAL_INFORMATION_NEXT"] = "signup nurse/personal information_next";
    TrackingEvent["SIGNUP_NURSE_UPLOAD_PHOTO"] = "signup nurse_upload photo";
    TrackingEvent["SIGNUP_PRO_CONFIRM_EMAIL"] = "signup pro_confirm email";
    TrackingEvent["SIGNUP_PRO_CONFIRM_PASSWORD_CONFIRM"] = "signup pro/confirm password_confirm";
    TrackingEvent["START_ADDING_SUPPLIES"] = "startAddingSupplies";
    TrackingEvent["START_PROCEDURE"] = "startProcedure";
    TrackingEvent["START_PROCEDURE_BAG_PACKING"] = "startProcedureBagPacking";
    /**
     * clicking pack on a procedure card. Packer starting a packing flow
     */
    TrackingEvent["START_PROCEDURE_KIT_PACKING"] = "startProcedureKitPacking";
    TrackingEvent["START_SHIFT_CHECKIN"] = "startShiftCheckin";
    TrackingEvent["START_WAYPOINT_ACTION"] = "startWaypointAction";
    TrackingEvent["SUBMIT_FEEDBACK"] = "submitFeedback";
    TrackingEvent["SUBMIT_LAB_INFO_FORM"] = "submit lab info form";
    TrackingEvent["SUBMIT_REQ_FORM"] = "submit requisition form";
    TrackingEvent["SUPPLIES_ADDED_TO_LOCATION"] = "suppliesAddedToLocation";
    /** Clicking "Issue with supplies?" on the Patient visit Appointment page */
    TrackingEvent["SUPPLIES_ERROR"] = "suppliesError";
    /**
     * Triggered when a supplyShipment is created and a placeID
     * has been assigned to a supplyTransfer
     */
    TrackingEvent["SUPPLY_TRANSFER_ASSIGNED"] = "supplyTransferAssigned";
    TrackingEvent["UNASSIGN_NURSE_FROM_SHIFT"] = "unassignNurseFromShift";
    TrackingEvent["UNASSIGN_NURSE_TO_ITINERARY"] = "unassignNurseToItinerary";
    TrackingEvent["UPDATE_DRAFT_WAYPOINT"] = "updateDraftWaypoint";
    TrackingEvent["UPDATE_ITINERARY"] = "updateItinerary";
    /**
     * This is triggered when either the Itinerary date or start time is modified
     *
     * Currently used on Dashboard
     */
    TrackingEvent["UPDATE_ITINERARY_START_TIME"] = "updateItineraryStartTime";
    TrackingEvent["UPDATE_NURSE_DOCUMENT_STATUS"] = "updateNurseDocumentStatus";
    TrackingEvent["UPDATE_NURSE_STATUS"] = "updateNurseStatus";
    TrackingEvent["UPDATE_PLACE_ACCOUNT"] = "updatePlaceAccount";
    TrackingEvent["UPDATE_PROCEDURE"] = "updateProcedure";
    TrackingEvent["UPDATE_PROCEDURE_DOCUMENT"] = "updateProcedureDocument";
    TrackingEvent["UPDATE_PRODUCT"] = "updateProduct";
    TrackingEvent["UPDATE_QA_STATUS"] = "updateQAStatus";
    TrackingEvent["UPDATE_SAMPLE"] = "updateSample";
    TrackingEvent["UPDATE_SHIFT"] = "updateShift";
    TrackingEvent["UPDATE_SUPPLY_ITEM"] = "updateSupplyItem";
    /**
     * Currently used server side on onWriteSupplyTransfer
     */
    TrackingEvent["UPDATE_SUPPLY_TRANSFER_STATUS"] = "updateSupplyTransferStatus";
    TrackingEvent["UPDATE_USER"] = "updateUser";
    TrackingEvent["UPDATE_WAYPOINT"] = "updateWaypoint";
    TrackingEvent["UPDATE_WAYPOINT_ACTION"] = "updateWaypointAction";
    TrackingEvent["USER_DELETED"] = "userDeleted";
    /** When user.notificationRecipient is updated */
    TrackingEvent["USER_NOTIFICATION_SUBSCRIPTION_UPDATED"] = "userNotificationSubscriptionUpdated";
    TrackingEvent["VIEW_RESULTS"] = "viewResults";
    /**
     * Pro Nurse, Packer - Triggered by `watchCurrentLocation`:
     * - On the first successful retrieval of coordinates
     * - On any failed retrieval of coordinates, or failure within the success
     *   callback, or detection of permissions revocation
     */
    TrackingEvent["WATCH_CURRENT_LOCATION"] = "watchCurrentLocation";
    TrackingEvent["WAYPOINT_ARRIVAL_DELAY"] = "waypointArrivalDelay";
    TrackingEvent["WAYPOINT_DELAY"] = "waypointDelay";
})(TrackingEvent || (TrackingEvent = {}));
export var RecipientOrderRole;
(function (RecipientOrderRole) {
    RecipientOrderRole["DRAW_PLACE"] = "drawPlace";
    RecipientOrderRole["NURSE"] = "nurse";
    RecipientOrderRole["PATIENT"] = "patient";
    RecipientOrderRole["PRESCRIBER"] = "prescriber";
    RecipientOrderRole["PRIMARY_CONTACT"] = "primaryContact";
    RecipientOrderRole["SCHEDULING_USER"] = "schedulingUser";
})(RecipientOrderRole || (RecipientOrderRole = {}));
//# sourceMappingURL=segment.js.map